import React from 'react'
import MetricCard from '../MetricCard'
import { Activity, Users, Store, PiggyBank, ShieldAlert } from 'lucide-react'

const DealSummary = ({appStats}) => {
  const cardDetails = [
    {
      icon: <PiggyBank size={24} />,
      title: "Total Revenue",
      value: `GHC ${parseFloat(appStats?.total_revenue).toFixed(2)}`,
      change: "10",
      period: "in the last 1 months"
    },
    {
      icon: <Activity size={24} />,
      title: "Active Deals",
      value: appStats?.active_deals,
      change: "10",
      period: "in the last 1 month"
    },
    {
      icon: <ShieldAlert size={24} />,
      title: "Expired Deals",
      value: appStats?.expired_deals,
      change: "10",
      period: "in the last 1 month"
    },
    {
      icon: <Store size={24} />,
      title: "Vendors",
      value: appStats?.total_vendors,
      change: "10",
      period: "in the last 1 month"
    },
    {
      icon:<Users size={24} />,
      title: "Subscribers",
      value: appStats?.total_subscribers,
      change: "10",
      period: "in the last 1 month"
    }
  ]
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-5">
      {
        cardDetails.map((card, index) => (
          <MetricCard key={index} {...card} />
        ))
      }
    </div>
  )
}

export default DealSummary